import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InitGuard } from '@core/guards/init.guard';
import { ApplyComponent } from '@features/job/apply/apply.component';
import { JobRoutingEnum } from '@features/job/job-routing.enum';
import { JobComponent } from '@features/job/job/job.component';

const routes: Routes = [
  {
    path: JobRoutingEnum.Root,
    canActivate: [InitGuard],
    component: JobComponent,
  },
  {
    path: JobRoutingEnum.JobApply,
    canActivate: [InitGuard],
    component: ApplyComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JobRoutingModule {}
